/*
 * Confidential and Proprietary.
 * Do not distribute without Bloom Harbor Gifts consent.
 * Copyright Bloom Harbor Gifts 2019. All rights reserved.
 */

import React, { useState } from 'react';
import Expansion from '@material-ui/core/ExpansionPanel';
import ExpansionSummary from '@material-ui/core/ExpansionPanelSummary';
import ExpansionDetails from '@material-ui/core/ExpansionPanelDetails';
import Typography from '@material-ui/core/Typography';
import { withStyles } from '@material-ui/core/styles';
import {
    shape, string, arrayOf, object,
} from 'prop-types';
import Grid from '@material-ui/core/Grid';
import { Add, Remove } from '@material-ui/icons';
import { useUIDSeed } from 'react-uid';
import LinkOrATag from '../../GraphqlCommonComponents/LinkOrATag/LinkOrATag';

const styles = (theme) => ({
    container: {
        maxWidth: 1440,
        margin: '0 auto',
    },
    mobileHeader: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        position: 'relative',
    },
    mobileHeaderBlock: {
        position: 'absolute',
        top: 40,
        textAlign: 'center',
        '& h1': {
            margin: '0',
            letterSpacing: 3,
        },
        '& p': {
            marginTop: 5,
        },
        '& a': {
            color: theme.palette.common?.black,
            fontWeight: 700,
            '& span': {
                marginLeft: 3,
            },
        },
    },
    mobileTagsBtn: {
        padding: '9px 0',
        '& span': {
            margin: 8,
            padding: 8,
            display: 'block',
            borderRadius: 26,
            color: theme.palette.common?.white,
            fontSize: 15,
            textAlign: 'center',
            fontWeight: 'bold',
        },
    },
    accordionTitle: {
        padding: '10px 0',
        textAlign: 'center',
        fontWeight: 'bold',
        margin: 0,
    },
    articleBlock: {
        '& $accordionSummary': {
            minHeight: 0,
            '& div': {
                margin: 0,
                flexGrow: 'inherit',
            },
        },
        '& $accordion': {
            margin: 0,
            boxShadow: 'none',
        },
    },
    accordionSummary: {
        textAlign: 'center',
        fontWeight: 'bold',
        '& span.MuiIconButton-label': {
            background: theme.palette.colorPrimary,
            borderRadius: '50%',
            '& svg': {
                color: theme.palette.common?.white,
                width: 22,
                height: 22,
            },
        },
        '& p': {
            fontSize: 14,
        },
    },
    articleGrid: {
        boxShadow: `0px 3px 4px  ${theme.palette.imageCardBoxShadow}`,
        minHeight: 215,
        margin: '15px 10px',
        '& img': {
            width: '100%',
        },
        '& a': {
            textDecoration: 'none',
            fontSize: 14,
            fontWeight: 600,
            color: theme.palette.common?.black,
        },
    },
    linkForTitle: {
        padding: 10,
        textAlign: 'center',
        position: 'relative',
    },
    accordion: {
        '&::before': {
            display: 'none',
        },
    },
    articleTitle: {
        padding: 3,
        borderRadius: 22,
        position: 'absolute',
        fontSize: 12,
        top: -18,
        left: 5,
        right: 5,
        margin: '0 auto',
    },
    articleTitleFirst: {
        width: 200,
    },
    bottomBanner: {
        '& img': {
            width: '100%',
            marginLeft: '4px',
        },
    },
});

// return mobile card block
const mobileCard = (classes, article, articleBlockStyle, key) => (
    <>
        {article?.image?.url && <img src={article.image.url} alt={article?.button_link?.title} />}
        <div className={classes.linkForTitle}>
            {article?.partner?.title && <span className={`${classes.articleTitle} ${key === 0  &&  classes.articleTitleFirst}`} style={articleBlockStyle}>{article.partner.title}</span>}
            {article?.button_link?.title}
        </div>
    </>
);

// return Mobile Article grid
const mobileArticleGrid = (classes, article, key, seed) => {
    const articleBlockStyle = {
        backgroundColor: article?.partner?.partner_background_color || '#7ec0c0',
        color: article?.partner?.partner_font_color || '#FFFFFF',
    };
    return (
        <Grid key={seed(article)} item xs={key === 0 ? 12 : 6}>
            <div className={classes.articleGrid}>
                { article?.button_link?.href
                    ? (
                        <LinkOrATag href={article.button_link.href}>
                            {mobileCard(classes, article, articleBlockStyle, key)}
                        </LinkOrATag>
                    ) : mobileCard(classes, article, articleBlockStyle, key)}
            </div>
        </Grid>
    );
};
// return Article block based on article conditon
const articleBlock = (classes, articleData, seed, firstThree = false) => articleData?.buttons?.map((article, index) => {
    if (firstThree) {
        return index <= 2 && mobileArticleGrid(classes, article, index, seed);
    }
    return  mobileArticleGrid(classes, article, index, seed);
});
// return Hero image block
const heroBlock = (classes, heroMobile) => {
    const titleStyle =  { color: heroMobile?.sub_title_font_color };
    const heroBlockStyle =  { textAlign: heroMobile?.text_and_button_alignment };
    return  (
        <div className={classes.mobileHeader}>
            <img src={heroMobile?.image?.url} alt={heroMobile?.link?.title} />
            <div className={classes.mobileHeaderBlock} style={heroBlockStyle}>
                <h1>{heroMobile?.header}</h1>
                <p style={titleStyle}>{heroMobile?.sub_title}</p>
                <LinkOrATag href={heroMobile?.link?.href}>{heroMobile?.link?.title}</LinkOrATag>
            </div>
        </div>
    );
};
// Scroll to section
const scrollToBlock = (id) => {
    if (typeof document !== 'undefined' && document.getElementById(id)) {
        document.getElementById(id).scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
};
const  SympathyArticleBlockMobile = ({ classes, data }) => {
    if (!data) {
        return null;
    }
    const { hero_image, article_section, bottom_banner } = data;
    const [expandedData, setExpand] = useState({
        isExpanded: {},
        blockKey: '',
    });
    const buttonBackgroundColor = data?.button_background_color?.color || '#7EBBC0';
    const heroMobile = hero_image?.find((hero) => hero?.name === 'Hero Mobile');
    const { isExpanded } = expandedData;
    const seed = useUIDSeed();
    return (
        <div className={classes.container}>
            {heroMobile && heroBlock(classes, heroMobile)}
            <div className={classes.mobileTagsBtn}>
                {article_section?.map((article) => (<span role="presentation" onClick={() => scrollToBlock(article?.title)} style={{ backgroundColor: buttonBackgroundColor }} key={seed(article)}>{article?.title}</span>))}
            </div>
            <div className={classes.articleBlock}>
                {article_section?.map((article, key) => (
                    <div id={article?.title} key={seed(article)}>
                        {article?.buttons?.length > 3
                            ? (
                                <Expansion className={classes.accordion}>
                                    <ExpansionSummary
                                        expandIcon={!isExpanded[`panel_${key}`]  ? <Add /> : <Remove />}
                                        className={classes.accordionSummary}
                                        aria-controls={`${key}panel-content`}
                                        id={`${key}panel-header`}
                                        onClick={() => {
                                            const expandPanel = isExpanded;
                                            expandPanel[`panel_${key}`] = !isExpanded[`panel_${key}`];
                                            setExpand({ isExpanded: expandPanel,  blockKey: key });
                                        }}
                                    >
                                        <Typography>{article?.title}</Typography>
                                    </ExpansionSummary>
                                    <ExpansionDetails>
                                        <Grid container>{articleBlock(classes, article, seed)} </Grid>
                                    </ExpansionDetails>
                                </Expansion>
                            )
                            : <p className={classes.accordionTitle}>{article?.title}</p> }
                        {!isExpanded[`panel_${key}`] && <Grid container>{articleBlock(classes, article, seed, true)} </Grid>}
                    </div>
                ))}
            </div>
            <Grid container className={classes.bottomBanner}>
                {bottom_banner?.link?.href
                    ? (
                        <LinkOrATag href={bottom_banner.link.href}>
                            <img src={bottom_banner.mobile_image?.url} alt={bottom_banner.mobile_image?.title} />
                        </LinkOrATag>
                    )
                    : <img src={bottom_banner.mobile_image?.url} alt={bottom_banner.mobile_image?.title} />}
            </Grid>
        </div>
    );
};
SympathyArticleBlockMobile.propTypes = {
    classes: object.isRequired,
    data: shape({
        title: string.isRequired,
        title_font_color: string.isRequired,
        sub_title: string.isRequired,
        sub_title_font_color: string.isRequired,
        main_button: arrayOf(shape({
            background_color: string.isRequired,
            font_color: string.isRequired,
            link: shape({
                href: string.isRequired,
                title: string.isRequired,
            }),
        })).isRequired,
        hero_image: arrayOf(shape({
            image: shape({
                url: string.isRequired,
            }),
            link: shape({
                href: string.isRequired,
            }),
        })).isRequired,
        article_section: arrayOf(
            shape({
                title: string.isRequired,
                image: shape({
                    url: string.isRequired,
                }),
                buttons: arrayOf(
                    shape({
                        value: shape({
                            button_background_color: string.isRequired,
                            button_font_color: string.isRequired,
                            copy: string.isRequired,
                            button_link: shape({
                                href: string.isRequired,
                                title: string.isRequired,
                            }),
                        }),
                    }),
                ),
            }),
        ).isRequired,
    }).isRequired,
};

export default withStyles(styles)(SympathyArticleBlockMobile);
